export default __webpack_public_path__ + "static/spot-kidney-fa4ef94fa60bf8380d93bf9fed78c305.jpg";